import { Box, Grid, Paper, TextField, Typography } from '@mui/material';
import React from 'react';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { MyButton } from '../../Styles/Styles';

const Contact = () => {
    return (
        <Box sx={{ p: { xs: 2, sm: 2, md: 5 }, pb: 15, borderRadius: '10px' }} component={Paper} elevation={5}>
            <Box>
                <Typography variant='h6' sx={{ fontWeight: '700', fontSize: { xs: '18px', sm: '21px' }, color: 'primary.main' }}>Contact me</Typography>
                <Typography variant='h4' sx={{ fontWeight: '700', fontSize: { xs: '25px', sm: '47px' } }}>Contact me to get <br /> your work done</Typography>
            </Box>

            <Box sx={{ mt: 8 }}>
                <Grid container columnSpacing={4}>
                    <Grid item xs={12} sm={12} md={4}>

                        <Box sx={{ display: { xs: 'block', sm: 'flex' }, alignItems: 'center', textAlign: {xs:'center', sm: 'left'}, gap: 2, mb: 3 }}>
                            <Box sx={{ backgroundColor: 'secondary.main', width: '80px', height: '80px', mx: { xs: 'auto', sm: '0' }, borderRadius: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <PhoneAndroidIcon sx={{ fontSize: '30px', color: '#fff' }} />
                            </Box>
                            <Box>
                                <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '21px' }}>Call Me</Typography>
                                <Typography variant='h6' sx={{ fontWeight: 300, fontSize: '16px', color: 'muted.main' }}>+123 456 7890</Typography>
                            </Box>
                        </Box>

                        <Box sx={{ display: { xs: 'block', sm: 'flex' }, alignItems: 'center', textAlign: {xs:'center', sm: 'left'}, gap: 2, mb: 3 }}>
                            <Box sx={{ backgroundColor: 'secondary.main', width: '80px', height: '80px', mx: { xs: 'auto', sm: '0' }, borderRadius: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <EmailIcon sx={{ fontSize: '30px', color: '#fff' }} />
                            </Box>
                            <Box>
                                <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '21px' }}>Email Us</Typography>
                                <Typography variant='h6' sx={{ fontWeight: 300, fontSize: '16px', color: 'muted.main' }}>hello@vaya.com</Typography>
                            </Box>
                        </Box>

                        <Box sx={{ display: { xs: 'block', sm: 'flex' }, alignItems: 'center', textAlign: {xs:'center', sm: 'left'}, gap: 2, mb: 3 }}>
                            <Box sx={{ backgroundColor: 'secondary.main', width: '80px', height: '80px', mx: { xs: 'auto', sm: '0' }, borderRadius: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <LocationOnIcon sx={{ fontSize: '30px', color: '#fff' }} />
                            </Box>
                            <Box>
                                <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '21px' }}>Address</Typography>
                                <Typography variant='h6' sx={{ fontWeight: 300, fontSize: '16px', color: 'muted.main' }}>20, Bardeshi, Amin Bazar</Typography>
                            </Box>
                        </Box>

                    </Grid>

                    <Grid item xs={12} sm={12} md={8}>
                        <Box>
                            <Grid container spacing={3}>

                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="Your Name" variant="outlined" sx={{ width: '100%' }} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="Your Email" variant="outlined" sx={{ width: '100%' }} />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="Your Phone" variant="outlined" sx={{ width: '100%' }} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="Subject" variant="outlined" sx={{ width: '100%' }} />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField id="outlined-basic" label="Your message here" variant="outlined" multiline rows={6} sx={{ width: '100%' }} />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <MyButton sx={{ fontSize: { xs: '15px', md: '20px' } }}>Submit Now</MyButton>
                                </Grid>

                            </Grid>
                        </Box>
                    </Grid>

                </Grid>
            </Box>

        </Box>
    );
};

export default Contact;